<template>
<div v-if="isLoaded">
    <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
        <div class="row match-height">
            <div class="col-xl-12 col-lg-12">
                <div class="card" style="">
                    <div class="card-header">
                        <h4 class="card-title">Tipo Calculo - Transportadora</h4>
                        <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                        <div class="heading-elements" v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                            <ul class="list-inline mb-0">
                                <li><a @click="onCreate()" v-b-tooltip title="Cadastrar" v-if="getPermissionFw('transptpcalc.store')"><i class="fa fa-plus"></i></a></li>
                                <li><a @click="onFilterReset()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                <li><a @click="onExtrairRelatorio()" v-b-tooltip title="Extrair Relatório"><i class="fa fa-print"></i></a></li>
                                <li><a @click="onImport()" v-b-tooltip title="Importar Parâmetro de cálculo" v-if="getPermissionFw('transptpcalc.store')"><i class="fa fa-code step-xml-nfe"></i></a></li>
                                <li><a @click="expandFullscreenFw()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                <li><a @click="expandFullscreenFw()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                <li><a @click="onFilterShowHideFw()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros" v-if="getPermissionFw('transptpcalc.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inutilizar Registros" v-if="getPermissionFw('transptpcalc.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="table-responsive">
                            <div v-if="vuetableFilterRow">
                                <vuetable-filterbar :tabela="'doc_fiscal'">
                                </vuetable-filterbar>
                            </div>
                            <div class="loadingDataPosition">
                                <div class="loadingData" v-if="loadingData">
                                    <div class="loadingDataSpinner">
                                        <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                    </div>
                                </div>
                                <vuetable ref="vuetable" api-url="/api/transptpcalc" :fields="fields" :css="css" :append-params="moreParams" track-by="pestrancal_id" pagination-path="" detail-row-component="transportadoratpcalc-detalhes" @vuetable:cell-clicked="onDetail" @vuetable:load-error="onError" @vuetable:pagination-data="onPaginationData" @vuetable:loaded="onLoaded">
                                    <template slot="transportadora" slot-scope="props">
                                        <span v-if="props.rowData.transportadora!==null && props.rowData.transportadora.pessoa_juridica!==null">PJ / {{props.rowData.transportadora.pessoa_juridica.razao_social}} CNPJ: {{onFormataCnpj(props.rowData.transportadora.pessoa_juridica.cnpj_base,props.rowData.transportadora.pessoa_juridica.cnpj_filial,props.rowData.transportadora.pessoa_juridica.cnpj_digito).replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/, "$1.$2.$3/$4-$5")}} IE: {{props.rowData.transportadora.pessoa_juridica.inscricao_estadual}}</span>
                                        <span v-if="props.rowData.transportadora!==null && props.rowData.transportadora.pessoa_fisica!==null">PF / {{props.rowData.transportadora.pessoa_fisica.nome}} - {{props.rowData.transportadora.pessoa_fisica.cpf}}</span>
                                        <span v-if="props.rowData.transportadora!==null && props.rowData.transportadora.pessoa_exterior!==null">PE / {{props.rowData.transportadora.pessoa_exterior.nome}} - {{props.rowData.transportadora.pessoa_exterior.cd}}</span>
                                        <span v-if="props.rowData.transportadora==null">Sem transportadora vinculada</span>

                                    </template>
                                    
                                    <template slot="tp_calc" slot-scope="props">
                                        <span>{{ props.rowData.tp_calc.descr }}</span>
                                    </template>
                                    <template slot="receita_despesa" slot-scope="props">
                                        <!-- <span>{{ props.rowData.tp_receita_despesa.descr }}</span> -->
                                        <span class="badge badge-danger" v-if="props.rowData.tp_receita_despesa.valor==2">{{ props.rowData.tp_receita_despesa.descr }}</span>
                                        <span class="badge badge-success" v-if="props.rowData.tp_receita_despesa.valor==1">{{ props.rowData.tp_receita_despesa.descr }}</span>
                                    </template>
                                    <!-- <template slot="unidade" slot-scope="props">
                                        <span v-if="props.rowData.carga_unidade!==null">{{ props.rowData.carga_unidade.unidade.descr }}</span>
                                    </template> -->
                                    <template slot="status" slot-scope="props">
                                        <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                        <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                    </template>
                                    <template slot="tp_operacao" slot-scope="props">
                                      <span class="badge badge-success">{{ props.rowData.tp_operacao.descr }}</span>
                                    </template>
                                    <template slot="tp_processo" slot-scope="props">
                                      <span class="badge badge-success" v-if="props.rowData.tp_processo!=null">{{ props.rowData.tp_processo.descr }}</span>
                                    </template>
                                    <template slot="unidade" slot-scope="props">
                                      <span v-if="props.rowData.unidade!=null">{{ props.rowData.unidade.descr}}</span>
                                    </template>
                                    <template slot="actions" slot-scope="props">
                                        <div class="custom-actions">
                                            <a @click="onEdit(props.rowData)" v-b-tooltip title="Editar"><i class="fa fa-edit"></i></a>
                                              <span v-if="getPermissionFw('transptpcalc.status')">
                                                <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                              </span>
                                            <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                            </button>
                                        </div>
                                    </template>
                                </vuetable>
                            </div>
                            <div>
                                <div class='col-md-12'>
                                    <div class="pull-left pagination-detail">
                                        <vuetable-pagination-info ref="paginationInfo" :css="css.pagination" info-class="pull-left"></vuetable-pagination-info>
                                    </div>
                                    <div class="pull-right m-a-0">
                                        <vuetable-pagination ref="pagination" :css="css.pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <TransportadoraTpCalcForm ref="transportadoratpcalcform">
        </TransportadoraTpCalcForm>
        <TransportadoraTpCalcExtrairForm ref="transportadoratpcalcextrairform">
        </TransportadoraTpCalcExtrairForm>
        <TransportadoraTpCalcImportarForm ref="transportadoratpcalcimportarform">
        </TransportadoraTpCalcImportarForm>
    </div>
</div>
</template>

<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import TransportadoraTpCalcFilterBar from "./TransportadoraTpCalcFilterBar";
import moment from "moment";
import accounting from "accounting";
import TransportadoraTpCalcDetalhes from "./TransportadoraTpCalcDetalhes";
import TransportadoraTpCalcForm from "./TransportadoraTpCalcForm";
import TransportadoraTpCalcExtrairForm from "./TransportadoraTpCalcExtrairForm";
import TransportadoraTpCalcImportarForm from "./TransportadoraTpCalcImportarForm";

import { formatCNPJFromParts } from "../utils";

Vue.component("transportadoratpcalc-detalhes", TransportadoraTpCalcDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    TransportadoraTpCalcForm,
    TransportadoraTpCalcExtrairForm,
    TransportadoraTpCalcImportarForm,
    "vuetable-filterbar": TransportadoraTpCalcFilterBar,
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      peso_bruto: "",
      checkbox: [],
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isLoadingCliente: false,
      optionsStatus: [],
      optionsStatusPessoa: [],
      optionsTpCalc: [],
      optionsTpReceitaDespesa: [],
      optionsTpReceitaDespesaFilter: [],
      optionsLivStatusFilter: [],
      optionsTpOperacao: [],
      optionsTpProcesso: [],
      optionsUnidade: [],
      optionsLivStatus: [],
      form: new Form({
        vlr_total_nfs: 0,
        vlr_total_peso_liquido: 0,
        vlr_total_peso_bruto: 0,
        vlr_total_volume: 0,
      }),
      helpForm: new Form({
        statusRecord: [],
        status: "",
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:transportadora", // <----
          title: "Transportadora",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:tp_calc", // <----
          title: "Tipo de cálculo",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:receita_despesa", // <----
          title: "Processo",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:tp_operacao", // <----
          title: "Operação",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:tp_processo", // <----
          title: "Tipo Processo",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:unidade", // <----
          title: "Unidade",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:status", // <----
          title: "Status",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },

        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        transportadora: data_filter.transportadora.value,
        status: data_filter.status.value,
        unidade: data_filter.unidade.value,
        tp_processo: data_filter.tp_processo.value,
        cliente: data_filter.cliente.value,
        tp_receita_despesa: data_filter.tp_receita_despesa.value,
        tp_calc: data_filter.tp_calc.value,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onCreate() {
      this.$refs.transportadoratpcalcform.onCreate();
    },
    onEdit(data) {
      this.$refs.transportadoratpcalcform.onEdit(data);
    },
    onExtrairRelatorio() {
      this.$refs.transportadoratpcalcextrairform.onCreate();
    },
    onImport(data) {
      this.$refs.transportadoratpcalcimportarform.errors_array = [];
      this.$refs.transportadoratpcalcimportarform.showModal = true;
    },
    getLivGeral() {
      this.helpForm
        .get("/api/transptpcalc/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach((obj) => {
            this.optionsStatus.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.status_pessoa.forEach((obj) => {
            this.optionsStatusPessoa.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_calc.forEach((obj) => {
            this.optionsTpCalc.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_operacao.forEach((obj) => {
            this.optionsTpOperacao.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_processo.forEach((obj) => {
            this.optionsTpProcesso.push({
              text: obj.descr,
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.unidade.forEach((obj) => {
            this.optionsUnidade.push({
              label: obj.cd+" - "+obj.descr,
              value: obj.unidade_id,
            });
          });

          response.tp_receita_despesa.forEach((obj) => {
            this.optionsTpReceitaDespesa.push({
              text: obj.descr,
              value: obj.valor,
            });
            this.optionsTpReceitaDespesaFilter.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.status.forEach((obj) => {
            this.optionsLivStatus.push({
              text: obj.descr,
              value: obj.valor,
            });
            this.optionsLivStatusFilter.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.pestrancal_id);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD MM YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({
          id: data.pestrancal_id,
          status: action,
        });
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push(obj);
        });
      }
      this.$refs.transportadoratpcalcform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  },
};
</script>